import ListTableColumnTag from '@components/list-table-column-tag'
import ListTableBaseAction from './list-table-base-action.vue'
import ListTableCustomAction from './list-table-custom-action.vue'
import ListTableStatus from './list-table-status.vue'

// 表格的配置
const tableConfig = {
  name: 'CourseList',
  mode: 'table',
  list: {
    type: 'Table',
    columns: [{
      prop: 'name',
      label: '课程名称',
      showOverflowTooltip: true,
      minWidth: '200'
    }, {
      prop: 'tags',
      label: '标签',
      // 自定义组件
      component: ListTableColumnTag,
      minWidth: '200'
    }, {
      prop: 'status',
      label: '状态',
      // 自定义组件
      component: ListTableStatus,
      minWidth: '100',
      statusMap: {
        2: {
          text: '停用',
          backgroundColor: '#faad14'
        },
        1: {
          text: '启用',
          backgroundColor: '#52c41a'
        }
      }
    }, {
      prop: 'courseWaresAmount',
      label: '课件数',
      minWidth: '100'
    }, {
      prop: 'creator',
      label: '创建人',
      minWidth: '160'
    }, {
      prop: 'createTime',
      label: '创建时间',
      minWidth: '160'
    }, {
      prop: 'action',
      label: '操作',
      width: '220',
      fixed: 'right',
      // 自定义组件
      component: ListTableCustomAction,
      actionMap: [
        {
          text: '统计分析',
          componentsName: 'button',
          componentsConfig: {
          },
          eventName: 'on-statistics-click'

        },
        {
          text: '编辑',
          componentsName: 'button',
          componentsConfig: {
          },
          eventName: 'on-edit-click'
        },
        {
          text: {
            2: '启用',
            1: '停用'
          },
          textByOtherKey: 'status',
          componentsName: 'popover',
          otherConfig: {
            tip: {
              2: '确认启用该课程吗？',
              1: '确认停用该课程吗？'
            },
            icon: 'tishi-info'
          },
          eventName: 'on-status-click'
        },
        {
          text: '删除',
          componentsName: 'popover',
          otherConfig: {
            tip: '确认删除该课程吗？'
          },
          eventName: 'on-delete-click'
        }
      ]
    }]
  }

}

export default tableConfig
